<template>
  <div class="modal-box">
    <div class="modal-title">
      <h3>Bewerk meting
      </h3>
      <div class="flex-divider"></div>
      <base-button
        type="secondary"
        @click="closeModal"
      >
        <base-icon iconRef="close" />
      </base-button>
    </div>
    <div class="modal-content">
      <div class="modal-content-section">
        <div class="input-header">
          <h4>Basisgegevens</h4>
        </div>
        <div class="input-container">
          <label class="label required">Metingtype</label>
          <select
            class="input"
            v-bind:value="newMeasurementData.type"
            @change="newMeasurementData.type = $event.target.value"
            v-validate="'required'"
            data-vv-as="Metingtype"
            name="measurementType"
          >
            <option value="Nulmeting">Nulmeting</option>
            <option value="Tussenmeting">Tussenmeting</option>
            <option value="Eindmeting">Eindmeting</option>
          </select>
          <base-input-warning :error="errors.first('measurementType')" />
        </div>
        <div class="input-container">
          <label class="label">Label</label>
          <base-input
            type="text"
            placeholder="Label"
            v-model="newMeasurementData.label"
          />
        </div>
        <div class="input-container">
          <label
            for
            class="label"
          >Beschrijving</label>
          <textarea
            class="input"
            rows="4"
            placeholder="Beschrijving"
            v-model="newMeasurementData.description"
          ></textarea>
        </div>
        <div class="input-row">
          <div class="input-container">
            <label class="label required">Meting door</label>
            <select
              class="input"
              name="author"
              id="author"
              v-model="newMeasurementData.author"
              data-vv-as="Meting door"
              v-validate="'required'"
            >
              <option
                :value="username"
                v-for="username in usersNames"
                :key="username"
              >{{username}}</option>
            </select>
            <base-input-warning :error="errors.first('author')" />
          </div>
          <div class="input-container">
            <label
              class="label required"
              for="date"
            >Datum</label>
            <base-datepicker v-model="newMeasurementData.date" />
          </div>
        </div>
      </div>
      <div class="modal-content-section">
        <div class="input-header">
          <h4>Meetwaarden</h4>
        </div>
        <div class="input-row">
          <div class="input-container">
            <label
              class="label required"
              for="hz125"
            >125 Hz</label>
            <base-input
              id="hz125"
              name="hz125"
              data-vv-as="125 Hz"
              v-validate="'required'"
              type="number"
              placeholder="0"
              v-model="newMeasurementData.hz125"
            />
            <base-input-warning :error="errors.first('hz125')" />
          </div>
          <div class="input-container">
            <label
              class="label required"
              for="hz250"
            >250 Hz</label>
            <base-input
              id="hz250"
              name="hz250"
              data-vv-as="250 Hz"
              v-validate="'required'"
              type="number"
              placeholder="0"
              v-model="newMeasurementData.hz250"
            />
            <base-input-warning :error="errors.first('hz250')" />
          </div>
          <div class="input-container">
            <label
              class="label required"
              for="hz500"
            >500 Hz</label>
            <base-input
              id="hz500"
              name="hz500"
              data-vv-as="500 Hz"
              v-validate="'required'"
              type="number"
              placeholder="0"
              v-model="newMeasurementData.hz500"
            />
            <base-input-warning :error="errors.first('hz500')" />
          </div>
        </div>
        <div class="input-row">
          <div class="input-container">
            <label
              class="label required"
              for="hz1000"
            >1000 Hz</label>
            <base-input
              id="hz1000"
              name="hz1000"
              data-vv-as="1000 Hz"
              v-validate="'required'"
              type="number"
              placeholder="0"
              v-model="newMeasurementData.hz1000"
            />
            <base-input-warning :error="errors.first('hz1000')" />
          </div>
          <div class="input-container">
            <label
              class="label required"
              for="hz2000"
            >2000 Hz</label>
            <base-input
              id="hz2000"
              name="hz2000"
              data-vv-as="2000 Hz"
              v-validate="'required'"
              type="number"
              placeholder="0"
              v-model="newMeasurementData.hz2000"
            />
            <base-input-warning :error="errors.first('hz2000')" />
          </div>
          <div class="input-container">
            <label
              class="label required"
              for="hz4000"
            >4000 Hz</label>
            <base-input
              id="hz4000"
              name="hz4000"
              data-vv-as="4000 Hz"
              v-validate="'required'"
              type="number"
              placeholder="0"
              v-model="newMeasurementData.hz4000"
            />
            <base-input-warning :error="errors.first('hz4000')" />
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <base-button
        @click="deleteMeasurement"
        type="danger"
        :loading="deletingMeasurement"
        :disabled="deletingMeasurement || editingMeasurement"
      >Verwijderen
      </base-button>
      <div class="flex-divider"></div>
      <base-button
        @click="closeModal"
        type="secondary"
      >Annuleren</base-button>
      <base-button
        @click="editMeasurement"
        :loading="editingMeasurement"
        :disabled="editingMeasurement || deletingMeasurement"
      >
        <base-icon
          iconRef="save"
          position="left"
        />Opslaan
      </base-button>
    </div>
  </div>
</template>

<script>
import Firebase from "firebase";

export default {
  data: function() {
    return {
      deletingMeasurement: false,
      editingMeasurement: false,
      newMeasurementData: {
        measurementName: "",
        description: "",
        type: "",
        label: "",
        author: "",
        date: "",
        hz125: "",
        hz250: "",
        hz500: "",
        hz1000: "",
        hz2000: "",
        hz4000: ""
      }
    };
  },
  computed: {
    usersList: function() {
      return this.$store.getters.getUsersList;
    },
    usersNames: function() {
      const usersNames = [];
      this.usersList
        .filter(user => {
          return user.data().includeInMeasurements;
        })
        .forEach(user => {
          usersNames.push(user.data().firstName + " " + user.data().lastName);
        });
      return usersNames;
    },
    currentMeasurement: function() {
      return this.$store.getters.getCurrentClientPage.measurement;
    },
    currentRoom: function() {
      return this.$store.getters.getRoomsList.find(room => {
        return room.id == this.currentMeasurement.data().belongsTo;
      });
    },
    currentMeasurementDate: function() {
      const currentDate = new Date(1970, 0, 1);
      currentDate.setSeconds(this.currentMeasurement.data().date.seconds);
      return currentDate;
    },
    currentMeasurementDisplayName: function() {
      let displayName = this.currentMeasurement.data().type;
      if (this.currentMeasurement.data().label.length > 0)
        displayName += `, ${this.currentMeasurement.data().label}`;
      return displayName;
    }
  },
  methods: {
    editMeasurement: function() {
      this.$validator.validate().then(result => {
        if (result) {
          this.editingMeasurement = true;
          const measurementData = {
            id: this.currentMeasurement.id,
            body: this.$editMeasurementDataObject(this.newMeasurementData)
          };
          Firebase.firestore()
            .collection("measurements")
            .doc(measurementData.id)
            .update(measurementData.body)
            .then(() => {
              Firebase.firestore()
                .collection("measurements")
                .doc(measurementData.id)
                .get()
                .then(doc => {
                  this.$store.commit("setCurrentClientPageMeasurement", doc);
                  this.editingMeasurement = false;
                  this.closeModal();
                });
            });
        }
      });
    },
    deleteMeasurement: function() {
      this.$dialog.confirm({
        message: `Weet je zeker dat je de meting:
        <p class="dialog-attention">${this.currentMeasurementDisplayName}</p>
        wilt verwijderen?`,
        cancelText: "Annuleer",
        confirmText: "Verwijder",
        type: "is-danger",
        onConfirm: () => {
          this.deletingMeasurement = true;
          const measurementData = {
            id: this.currentMeasurement.id,
            body: this.$deleteMeasurementDataObject()
          };
          this.$store.dispatch("editMeasurement", measurementData).then(() => {
            this.deletingMeasurement = false;
            this.closeModal();
            this.$router.push(`/ruimte/${this.currentRoom.id}`);
          });
        }
      });
    },
    closeModal: function() {
      this.$store.commit("setModalShown", {
        dataType: "measurement",
        modalType: "edit",
        shown: false
      });
    }
  },
  mounted: function() {
    this.newMeasurementData = Object.assign({}, this.currentMeasurement.data());
    this.newMeasurementData.date = this.currentMeasurement.data().date.toDate();
  }
};
</script>



// WEBPACK FOOTER //
// src/components/modal-components/measurement-edit-modal.vue